const a = {
  s0289cd9e4bcf84c5: "Nivel de volumen",
  s061cc20e3432dead: "Pausar",
  s0622a6e6cb77254b: "Transcripción",
  s080d032fc1b87b3f: "Descripción de audio",
  s08b06007b5567108: "de",
  s08e6bd98452e6bb9: "Audio",
  s1b4a36fce2456660: "Familia de fuentes",
  s1fa5be5a4f5d0f04: "Informal",
  s23537b5c9e7af982: "Subtítulos",
  s24221a89168e9d21: "Tamaño de fuente",
  s255857544a9d5ec0: "Restablecer",
  s25a858f0257e2879: "Menú Subtítulos",
  s2df075aface0dab8: "Compartir",
  s2f5d5d2d1f92de26: "Descargar vídeo",
  s302cbb19bf9a174a: "Desactivado",
  s308604b3ae13fbb5: "Reproduciendo",
  s344ea8f4939cdc98: "Color",
  s3687049d1af562c4: "Copiar",
  s36b979e4de5152b3: "Vínculo copiado",
  s37a9e8aec5713460: "Más",
  s3ca1bdfa8785f808: "Sans Serif proporcional",
  s41faaf3b4e182cc6: "Es necesario realizar una comprobación de la edad para acceder a este contenido.",
  s49f06dca0feeb2f3: "Uniforme",
  s4b023aafbd8d5ac8: "Comparte este vídeo por",
  s4b10acae683d2978: "Pantalla completa",
  s500caa88d20458d3: "No puedes acceder a este contenido",
  s5267658ceae3230f: "Compartir este vídeo",
  s5c5db15dfc3a5376: "Velocidad de reproducción",
  s5e3cb80d43a34044: "Negro",
  s5e8250fb85d64c23: "Cerrar",
  s669b18c6d2d9c95b: "Ninguna",
  s66d852e3c020e79e: "Opaco",
  s6a3bf589eaf72169: "Serif monoespaciada",
  s6baf78886c99db89: "Amarillo",
  s6f59e9b81c5a47e0: "Sombra paralela",
  s711d047dea682c1a: "Pista de audio",
  s7d148a08796094d2: "Error de reproducción",
  s81a19821f3e4a3d2: "Reproducir",
  s827bc70ebcb7bbc6: "Sans Serif monoespaciada",
  s85186a61e0d55bac: "Vídeo",
  s889413eb7198ea01: "opción para desactivar los subtítulos",
  s8e408592fd4ae43a: "Estilo de borde del texto",
  s8e985aeeca6a8166: "Blanco",
  s8eafb22ebdc7e668: "Magenta",
  s9559a51a63cbb5fd: "Versalitas",
  s95bc8722b2708f8b: "En pausa",
  s973b83fb67a5865d: "Descargar transcripción",
  s9b3c2f9cc32d565a: "Cian",
  s9c356016f81585f6: "Color de fondo",
  s9d8b8aa2b404c2c8: "Configuración",
  s9fbd543f2179c1ec: "Menú Audio",
  sa000eaf7092088c3: "Barra de progreso",
  sa6f2645578b2d2bc: "Año",
  sa9011e79e3ca2d18: "Presionado",
  saf9b398ab363c174: "Escribe tu fecha de nacimiento",
  sb3d4f79d9d8b71e5: "Enviar",
  sb47daaf9e1c4a905: "Mes",
  sb9f16a5f9c29f41e: "Lo sentimos, se ha producido un error.",
  sba64d8954d027206: "Opacidad",
  sc07837c309cc699b: "Reactivar audio",
  scd105819b5a10243: "Reproducir",
  sce836928a17d96ed: "Color del texto",
  scf00d78fd5953f1c: "Verde",
  sd1246235faaa3191: "Se ha aplicado una restricción de edad debido a temas para adultos o requisitos legales destinada a proteger a las audiencias más jóvenes.",
  sd3386a2ef42e80b9: "Descargar",
  sd8d4b1b613d28990: "Cursiva",
  sdb02f53e62c1da05: "Elevado",
  sdb73788b3c975f16: "Automático",
  se0955919920ee87d: "Día",
  se0f67eae944f8f94: "Silenciar",
  se73c59cc10f48c12: "Redes sociales",
  secf3d3a7c1693e2d: "Azul",
  sed31876562d94652: "Configuración de las leyendas",
  sf113fa256db9617b: "Finalizado",
  sf675f879b1c892c6: "Calidad",
  sfc24a457269b13d4: "Control deslizante de volumen",
  sfcb817633bf70e1b: "Serif proporcional"
};
export {
  a as templates
};
